import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: "https://9aba2699dde71f1ae5544345b51a29f9@o4507385235570688.ingest.de.sentry.io/4508795267055696",
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllInputs: false,
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
        "localhost",
        "127.0.0.1",
        "https://panel.elithair.tech/",
        // TODO: Uncomment these when we have a proper domain
        // /^https:\/\/medisoft\.elitklinik\.io\/api/,
        // /^https:\/\/api\.elitklinik\.com\/api/,
        // /^https:\/\/operation-service-e92798f49dc2\.herokuapp\.com\//,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    enabled: import.meta.env.PROD,
});
